import React, { useState } from 'react'
import { connect } from 'react-redux'
import { setCercleProportionnel } from '../redux/actions'

function CercleProportionnel(props) {

    const [cercleproportionnel, setCercleproportionnel] = useState("");
    const [siaffichercercleproportionnel, setSiAfficherCercleproportionnel] = useState(false);

    const onChangeCercleProportionnel = (val) => {
        setSiAfficherCercleproportionnel(true);
        setCercleproportionnel(val.target.value);
    }

    const onChangeSiAfficherCercleProportionnel = (val) => {
        setSiAfficherCercleproportionnel(!siaffichercercleproportionnel);
        props.setCercleProportionnel()
    }


    if (cercleproportionnel !== "" && siaffichercercleproportionnel) {
        // eslint-disable-next-line
        var liste = props.listecerclesproportionnel.filter(a => a.id_indicateur == cercleproportionnel);

        if (liste.length > 0) {
            props.setCercleProportionnel(liste[0]);
        }
    }
    else {
        if (props.cerclesproportionnel) {
            props.setCercleProportionnel();
        }
    }


    return (
        <>
            <div className="col-12 tuile ombre">
                <div className="row">
                    Taille des ronds proportionnelle à une variable
                </div>
                <div className="row">
                    <div className="col-2 sansmarge">
                        <div className="couleurtheme">
                            {/* <input type="checkbox" id="afficher4" checked={siaffichercercleproportionnel} onChange={onChangeCercleProportionnel} /> */}
                            <input type="checkbox" id="afficher4" checked={siaffichercercleproportionnel} onChange={onChangeSiAfficherCercleProportionnel} />
                            <img id="cercles" src={`${process.env.PUBLIC_URL}/images/proportionnalite.png`} style={{ width: 27, height: 12 }} alt="" />
                        </div>
                    </div>
                    <div className="col-2 sansmarge">
                        Variable
                    </div>
                    <div className="col-8 sansmarge" >
                        <select id="variable4" className="semi-square" style={{ minWidth: "100%" }} value={cercleproportionnel} onChange={onChangeCercleProportionnel}>
                            <option value={""}></option>
                            {
                                props.listecerclesproportionnel ?
                                    props.listecerclesproportionnel.map((a, id) => <option key={id} value={a.id_indicateur}>{a.nomafficher.replace('$$', a.annee)}</option>)
                                    : null
                            }
                        </select>
                    </div>
                </div>
            </div>
            <div className="col-12 tuile masquer" id="reglages4">
                <div className="row">
                    <div className="col-6 tuile ">
                        <div>Valeur minimale à afficher</div>
                        <input type="number" id="min4" />
                        <input type="range" id="rangemin4" />
                    </div>
                    <div className="col-6 tuile">
                        <div style={{ width: "100%", textAlign: "right" }}>Valeur maximale à afficher</div>
                        <input type="range" id="rangemax4" />
                        <input type="number" id="max4" />
                    </div>
                </div>
            </div>
        </>
    )
}



function mapStateToProps(state) {
    return {
        listecerclesproportionnel: state.listecerclesproportionnel,
        cerclesproportionnel: state.cerclesproportionnel
    }
}

export default connect(mapStateToProps, { setCercleProportionnel })(CercleProportionnel);
